/**
 * PDF Color palette - RGB values for jsPDF styling
 * Modern, attractive, professional design
 */
export type PdfColor = [number, number, number];

export const PDF_COLORS: Record<string, PdfColor> = {
  // 🔵 Corporate Blue (your choice)
  primary: [0, 77, 149], // #004D95 (main headers)
  primarySoft: [0, 102, 178], // slightly lighter blue (sub headers)
  primaryLight: [230, 240, 250], // very light blue (row bg)

  // ✅ Semantic (keep muted)
  success: [34, 94, 60], // dark green
  danger: [136, 42, 42], // muted red

  // ⚪ Neutrals (important balance)
  dark: [33, 37, 41], // main text (NOT blue)
  secondary: [64, 130, 197], // secondary text
  secondaryLight: [230, 240, 250], // subtle backgrounds
  border: [222, 226, 230], // clean borders
  white: [255, 255, 255],
};

/**
 * Enhanced PDF Layout - Better spacing, modern look
 */
export const PDF_LAYOUT = {
  pageWidth: 210,
  pageHeight: 297,
  margin: 16, // Slightly increased margins
  headerHeight: 45,
  sectionHeaderHeight: 12,
  summaryCardHeight: 40,
  lineHeight: 6,
};

/**
 * Typography - Professional scaling
 */
export const PDF_FONTS = {
  title: 24, // Smaller, elegant title
  subtitle: 12,
  date: 10,
  sectionHeader: 15, // Bolder sections
  tableHeader: 11,
  tableBody: 10,
  footer: 9,
};
